import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from 'react';
import { Spin } from "antd";
import axios from "axios";
import { CheckCircleTwoTone, ExclamationCircleTwoTone, TagsOutlined } from "@ant-design/icons";
import { axiosErrorHandler } from "../../../../../swzutils";
import HelpLabel from "../../../components/HelpLabel";
import ValOrDash from "../../../components/ValOrDash";
import DashboardConstants from "../DashboardConstants";
const CompanyVehicleAssignedConsignmentsWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    // useEffect(() => {
    //     if (props.date) {
    //         refresh();
    //     }
    // }, [props.date]);
    const refresh = () => {
        load();
    };
    const load = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/company-vehicle-assign-deliveries/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(axiosErrorHandler)
            .finally(() => setStateLoading(false));
    };
    const { assignedAndCompletedConsignments, vehiclesWithCustomerDeliveries, averageDeliveriesPerCompanyVehicle, averageDeliveriesPerVehicleTarget, } = stateData ?? {};
    const deliveriesShortfall = stateData?.deliveriesShortfall ?? 0;
    const icon = deliveriesShortfall <= 0
        ? _jsx(CheckCircleTwoTone, { twoToneColor: DashboardConstants.SUCCESS_ICON_COLOR })
        : _jsx(ExclamationCircleTwoTone, { twoToneColor: DashboardConstants.WARNING_ICON_COLOR });
    const textColor = averageDeliveriesPerVehicleTarget
        ? (deliveriesShortfall <= 0 ? DashboardConstants.SUCCESS_ICON_COLOR : DashboardConstants.WARNING_ICON_COLOR)
        : undefined;
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-coral", children: _jsx(TagsOutlined, {}) }), _jsxs("h2", { className: "widget-value", children: [_jsxs("span", { style: { color: textColor }, children: [_jsx(ValOrDash, { val: averageDeliveriesPerCompanyVehicle }), averageDeliveriesPerVehicleTarget ? _jsxs("span", { className: "small", children: ["/", averageDeliveriesPerVehicleTarget] }) : ""] }), "\u00A0", averageDeliveriesPerVehicleTarget ? icon : null, (deliveriesShortfall > 0) && _jsxs("span", { className: "small", children: ["\u00A0(Delivery shortfall: ", deliveriesShortfall, ")"] })] }), _jsx("p", { children: _jsx(HelpLabel, { title: "Average deliveries per company vehicle", helpText: _jsx("p", { children: "The average number of deliveries per company vehicle." }) }) }), _jsx("div", { className: "widget-separator" }), _jsxs("h2", { className: "widget-value", children: [_jsx(ValOrDash, { val: vehiclesWithCustomerDeliveries }), "\u00A0", _jsxs("span", { className: "small", children: ["(", _jsx(ValOrDash, { val: assignedAndCompletedConsignments }), " deliveries)"] })] }), _jsx("p", { children: _jsx(HelpLabel, { title: "Company vehicles with deliveries", helpText: _jsx("p", { children: "The total number of company vehicles that have deliveries assigned to them. Note that vehicles that are not considered delivery vehicles are excluded from this." }) }) })] }) }));
};
export default React.forwardRef(CompanyVehicleAssignedConsignmentsWidget);
